export const AddRespondentsLink = 'add-respondents';
export const LanguageLink = 'language';
export const SenderLink = 'sender';
export const ConfirmAndSendLink = 'confirm-and-send';
export const ConfirmDateLink = 'confirm-date';
export const SetScheduleLink = 'set-schedule';
export const cpsPageUrlAnchor = 'create_plan_send';
export const cpsIntermediatePageUrlAnchor = 'create_plan_send_intermediate';
export const SetLocation = 'location';
export const TagsLink = 'tags';
export const ProjectNameLink = 'project-name';
export const ProjectResponsibleLink = 'project-responsible';
export const PortfolioLink = 'portfolio';
export const OldProjectTemplateLink = 'project-template';
export const ProjectCategoryLink = 'project-category';
export const ProjectQuestionsLink = 'project-questions';
export const BudgetLink = 'budget';
export const SubscriptionLink = 'subscription';
export const CreateProjectDoneLink = 'create/project-done';
export const PlanPlanningDoneLink = 'plan/planning-done';
export const SendConfirmAndSendLink = 'send/confirm-and-send';
export const CustomizeQuestionnaireLink = 'customize-questionnaire';
